import React from "react";
// import BgPhoto from "../../assets/images/bgnew.png";
import BgPhoto from "../../assets/images/bg2023.png";
import { Col, Container, Row } from "react-bootstrap";
import "./Layout.css";

const Layout = ({ props, children }: { props: any; children: any }) => {
  return (
    <>
      <Container
        style={{
          backgroundImage: `url(${BgPhoto})`,
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
          backgroundPosition: "center top",
        }}
        className="cont-height"
        fluid
      >
        <Row>{children}</Row>

        <Row>
          <Col lg={2} xxl={2} xs={12}></Col>
          <Col lg={8} xxl={8} xs={12}>
            <p style={styles.mail}>
              In case of any clarifications or queries , please write to{" "}
              <a href="mailto:ethics@mahindra.com" style={styles.mail1}>
                ethics@mahindra.com
              </a>{" "}
              <br />
              In case you are facing any technical or login related
              challenges,please send mail to{" "}
              <a
                href="mailto:mahindrarisesupport@mahindra.com"
                style={styles.mail1}
              >
                mahindrarisesupport@mahindra.com
              </a>
            </p>
          </Col>
          <Col lg={2} xxl={2} xs={12}></Col>
        </Row>
      </Container>
    </>
  );
};

const styles: any = {
  mail: {
    textAlign: "center",
    fontSize: "14px",
    color: "#fff",
  },

  mail1: {
    color: "#dc3545",
    backgroundColor: "#fff",
  },
};

export default Layout;
